import React from 'react';
import {SPLIT_DELIMITER} from "../../../placement/const";
import CancelIcon from "@material-ui/icons/Cancel";
import {AuthorizationListAction, AuthorizationListFilterValue} from "./authorizationListReducer";
import {asQueryParam} from "./AuthorizationListFilter";
import {
    AuthorizationTypeMap,
    ClientReportReportStatusMap,
    ParentCaseServiceTypeNameToValue
} from "../domain";
import {formatDate} from "../../../common/util/date";


type AuthorizationListFilterBadgeProps = {
    filter: AuthorizationListFilterValue
    dispatch: React.Dispatch<AuthorizationListAction>
}

export function AuthorizationListFilterBadge({filter, dispatch}: AuthorizationListFilterBadgeProps) {
    let values: Array<string> = [];

    const params = asQueryParam(filter);
    if (params.serviceTypes) {
        values = values.concat(params.serviceTypes);
    }
    if (params.reportStatus) {
        values = values.concat(params.reportStatus);
    }
    if (params.status) {
        values = values.concat(params.status);
    }
    if (params.recordType) {
        values = values.concat(params.recordType);
    }
    if (params.faRecordType) {
        values = values.concat(params.faRecordType);
    }

    if (filter.reportSubmittedDateFrom !== null) {
        values = values.concat(`Report submitted date from: ${formatDate(filter.reportSubmittedDateFrom!)}`);
    }
    if (filter.reportSubmittedDateTo !== null) {
        values = values.concat(`Report submitted date to: ${formatDate(filter.reportSubmittedDateTo!)}`);
    }
    if (filter.reportDueDateFrom !== null) {
        values = values.concat(`Report due date from: ${formatDate(filter.reportDueDateFrom!)}`);
    }
    if (filter.reportDueDateTo !== null) {
        values = values.concat(`Report due date to: ${formatDate(filter.reportDueDateTo!)}`);
    }

    const updateFilterByRemoveValue = (value: string) => {
        if (value) {
            if (value.includes("Report due date from:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, reportDueDateFrom: null}});
                return;
            }

            if (value.includes("Report due date to:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, reportDueDateTo: null}});
                return;
            }

            if (value.includes("Report submitted date from:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, reportSubmittedDateFrom: null}});
                return;
            }

            if (value.includes("Report submitted date to:")) {
                dispatch({type: 'SET_FILTER', filter: {...filter, reportSubmittedDateTo: null}});
                return;
            }

            const keyArr = [
                "status",
                "authType",
                "serviceType",
                "reportStatus",
            ];
            for (let i = 0; i < keyArr.length; i++) {
                const key = keyArr[i] as "status" | "serviceType" | "authType" | "reportStatus";
                const filterOptions = (filter[key] as string).split(SPLIT_DELIMITER);
                if (filterOptions.includes(value)) {
                    const newOptions = filterOptions.filter((val) => val !== value).join(SPLIT_DELIMITER);
                    const newFilter = {...filter};
                    newFilter[key] = newOptions;
                    dispatch({type: 'SET_FILTER', filter: newFilter});
                    return
                }
            }
        }
    }

    const displayValue = (value: string) => {
        if (ParentCaseServiceTypeNameToValue.get(value)) {
            return ParentCaseServiceTypeNameToValue.get(value);
        }

        if (AuthorizationTypeMap.get(value)) {
            return AuthorizationTypeMap.get(value);
        }

        if (ClientReportReportStatusMap.get(value)) {
            return ClientReportReportStatusMap.get(value);
        }

        return value;
    }

    if (values.length === 0) {
        return <div/>;
    }

    return (
        <div className='flex pl-5 items-start'>
            <div className='pt-2 pr-5 flex-grow-0'>
                Filter:
            </div>
            <div className='flex flex-grow flex-wrap'>
                {
                    values.map((value) => (
                        <div key={value}
                             className='mr-2 mb-2 bg-botticelli-100 text-white p-2 rounded leading-none flex items-center'>
                            {displayValue(value)}
                            <button className='bg-transparent outline-none focus:outline-none'
                                    onClick={() => updateFilterByRemoveValue(value)}>
                                <div
                                    className='bg-transparent text-white opacity-5 ml-3 outline-none focus:outline-none flex items-center'>
                                    <CancelIcon fontSize={"small"}/>
                                </div>
                            </button>
                        </div>
                    ))
                }
            </div>
        </div>);
}


